PJQ.models.sessions = {};
PJQ.models.sessions.Session = PJQ.models.BaseModel.extend({
    idAttribute: 'sessionId',
    endpoint: '/session',
    coreFields: {
        contact: {},
        user: {}
    },
    customFields: {
        company: {},
        contact: {},
        project: {},
        actionItems: {},
        punchList: {},
        rfi: {},
        primeContracts: {},
        payableInvoices: {},
        receivableInvoices: {},
        schedule: {},
        submittals: {},
        user: {},
        meetings: {}
    },
    groups: {},
    data: {
        dailyReports: {
            templates: null
        }
    },
    fetch(opts) {
        if (1 === 2) {
            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'token'
                    }
                ]),
                isAPIv2: true
            }).get().done(_.bind(_.bind(function (data) {
                this.set('accessToken', data.access_token);
            }, this)));
        }
        return PJQ.models.BaseModel.prototype.fetch.call(this, opts);
    },
    parse: function (model) {
        if (model && _.size(model) > 0) {
            if (this.preferences && model.preferences != null) {
                this.preferences.set(model.preferences);
                this.preferences.parse(model.preferences);
            } else if (model.preferences != null) {
                if (model.preferences instanceof PJQ.models.preferences.Preferences)
                    this.preferences = model.preferences;
                else
                    this.preferences = new PJQ.models.preferences.Preferences(model.preferences);
            } else {
                this.preferences = new PJQ.models.preferences.Preferences();
            }

            this.subscription = new PJQ.models.subscriptions.Subscription(model.subscription);

            if (model.systemPermissions != null) {
                this.systemPermissions = new PJQ.models.permissions.SystemPermissions(model.systemPermissions);
            } else {
                this.systemPermissions = null;
            }

            if (this.userTypes != null && model.userTypes != null) {
                this.userTypes.reset(model.userTypes);
            } else if (model.userTypes != null) {
                if (model.userTypes instanceof PJQ.collections.userTypes.UserTypes)
                    this.userTypes = model.userTypes;
                else
                    this.userTypes = new PJQ.collections.users.Users(model.userTypes);
            } else {
                this.userTypes = new PJQ.collections.userTypes.UserTypes();
            }

            if (this.project != null && model.project != null) {
                this.project.set(model.project);
                this.project.parse(model.project);
            } else if (model.project != null) {
                if (model.project instanceof PJQ.models.projects.Project)
                    this.project = model.project;
                else
                    this.project = new PJQ.models.projects.Project(model.project);
            } else {
                this.project = null;
            }

            if (this.contact != null && model.contact != null) {
                this.contact.set(model.contact);
                this.contact.parse(model.contact);
            } else if (model.contact != null) {
                if (model.contact instanceof PJQ.models.contacts.Contact)
                    this.contact = model.contact;
                else
                    this.contact = new PJQ.models.contacts.Contact(model.contact);
            } else {
                this.contact = null;
            }

            if (this.user != null && model.user != null) {
                this.user.set(model.user);
                this.user.parse(model.user);
            } else if (model.user != null) {
                if (model.user instanceof PJQ.models.users.User)
                    this.user = model.user;
                else
                    this.user = new PJQ.models.users.User(model.user);
            } else {
                this.user = null;
            }

            if (this.users != null && model.users != null) {
                this.users.reset(model.users);
            } else if (model.users != null) {
                if (model.users instanceof PJQ.collections.users.Users)
                    this.users = model.users;
                else
                    this.users = new PJQ.collections.users.Users(model.users);
            } else {
                this.users = new PJQ.collections.users.Users();
            }

            this.emailTemplates = {};
            this.emailTemplates.projectMessage = null;
        } else {
            this.systemPermissions = null;
            this.preferences = new PJQ.models.preferences.Preferences();
            this.project = null;
            this.contact = null;
            this.user = null;
            this.users = new PJQ.collections.users.Users();
            this.userTypes = new PJQ.collections.userTypes.UserTypes();
            this.emailTemplates = {};
            this.emailTemplates.projectMessage = null;
        }
        return model;
    },
    joinDirectory: function (callback) {
        let hasContact = this.contact != null;
        if ((!hasContact || this.contact.get('isBlacklisted')) && this.user != null) {
            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'users'
                    },
                    {
                        endpoint: 'joindirectory'
                    }
                ])
            }).post().done(_.bind(function (contact) {
                this.contact = new PJQ.models.contacts.Contact(contact);
                if (PJQ.app.navigator != null) {
                    PJQ.app.navigator.refreshCommands();
                }
                PJQ.notifications.notify.successNotify({
                    message: 'You have ' + (hasContact ? 'activated' : 'joined') + ' the Pantera contractor directory'
                });
                if (typeof callback === 'function') {
                    callback();
                }
            }, this));
        }
    },
    leaveDirectory: function (callback) {
        if (this.contact != null && this.user != null) {
            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'users'
                    },
                    {
                        endpoint: 'leavedirectory'
                    }
                ])
            }).post().done(_.bind(function (contact) {
                this.contact.set('isBlacklisted', true);
                if (PJQ.app.navigator != null) {
                    PJQ.app.navigator.refreshCommands();
                }
                PJQ.notifications.notify.successNotify({
                    message: 'You have de-activated the Pantera contractor directory'
                });
                if (typeof callback === 'function') {
                    callback();
                }
            }, this));
        }
    },
    isPanteraPortal: function () {
        return this.get('portalId') === 4;
    },
    hasPermission: function (permission, options = {}) {
        if ((!PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_PERMISSIONS) && !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_PERMISSIONS_PORTAL)) || _.size(permission) === 0) {
            return true;
        } else if (this.systemPermissions == null) {
            return false;
        }
        return this.systemPermissions.hasPermission(permission, options);
    },
    fetchERPIntegration: function (callback = null) {
        return new Promise((resolve, reject) => {
            let cb = (erp) => {
                if (typeof callback === 'function') {
                    callback(erp);
                }
                resolve(erp);
            }

            if (PJQ.app.session.user == null || (PJQ.app.session.get('portalId') !== PJQ.constants.panteraPortalId && !PJQ.app.session.get('ownsPortal'))) {
                cb(null);
                return;
            }

            if (this.erpIntegration != null) {
                cb(this.erpIntegration);
                return;
            }

            if (this.integrations != null) {
                this.erpIntegration = this.integrations.findWhere({erp: true});
                if (this.erpIntegration != null) {
                    cb(this.erpIntegration);
                    return;
                }
            }

            let eInt = new PJQ.integrations.models.Integration({}, {
                erp: true
            });
            eInt.fetch({
                success: () => {
                    if (eInt.id > 0) {
                        this.erpIntegration = eInt;
                    }

                    cb(this.erpIntegration);
                },
                error: () => {
                    cb(null);
                    reject(new Error("Failed to fetch erp integration"));
                }
            });
        });
    },
    fetchIntegrations: function (callback) {
        if (this.integrations == null) {
            this.integrations = new PJQ.integrations.collections.Integrations();
            this.integrations.fetch({
                success: _.bind(function () {
                    if (typeof callback === 'function') {
                        callback(this.integrations);
                    }
                }, this)
            });
        } else {
            callback(this.integrations);
        }
    },
    fetchUserLimits: function (callback) {
        if (this.userLimits == null) {
            this.userLimits = new PJQ.models.companies.UserLimits();
            this.userLimits.fetch({
                success: _.bind(function () {
                    if (typeof callback === 'function') {
                        callback(this.userLimits);
                    }
                }, this)
            });
        } else {
            callback(this.userLimits);
        }
    },
    fetchNDAs: function (callback) {
        if (this.ndas == null) {
            this.ndas = new PJQ.collections.projects.ProjectNDAs(null);
        }

        if (!this.ndas.isFetched) {
            this.ndas.fetch({
                success: _.bind(function () {
                    callback(this.ndas);
                }, this)
            });
        } else {
            callback(this.ndas);
        }
    },
    fetchSystemPermissions: function (callback) {
        this.systemPermissions = new PJQ.models.permissions.SystemPermissions();
        this.systemPermissions.fetch({
            success: _.bind(function () {
                callback(this.systemPermissions);
            }, this)
        });
    },
    fetchBidPackageTemplates: function (callback) {
        if (this.bidPackageTemplates == null) {
            this.bidPackageTemplates = new PJQ.collections.bidPackages.Templates();
            this.bidPackageTemplates.fetch({
                success: _.bind(function () {
                    if (typeof callback === 'function') {
                        callback(this.bidPackageTemplates);
                    }
                }, this)
            });
        } else {
            callback(this.bidPackageTemplates);
        }
    },
    fetchBidFormTemplates: function (callback) {
        this.bidFormTemplates = new PJQ.collections.bidForms.Templates();
        this.bidFormTemplates.fetch({
            success: _.bind(function () {
                if (typeof callback === 'function') {
                    callback(this.bidFormTemplates);
                }
            }, this)
        });
    },
    fetchBidFormSettings: function (callback) {
        if (this.bidFormSettings == null) {
            this.bidFormSettings = new PJQ.models.bidForms.Settings();
            this.bidFormSettings.fetch({
                success: _.bind(function () {
                    callback(this.bidFormSettings);
                }, this)
            });
        } else {
            callback(this.bidFormSettings);
        }
    },
    fetchUnitsOfMeasure: function (callback) {
        if (this.unitsOfMeasure == null) {
            this.unitsOfMeasure = new PJQ.collections.budget.UnitsOfMeasure();
            this.unitsOfMeasure.fetch({
                success: _.bind(function () {
                    callback(this.unitsOfMeasure);
                }, this)
            })
        } else {
            callback(this.unitsOfMeasure);
        }
    },
    fetchCostCodes: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.costCodes != null) {
                if (typeof callback === 'function') {
                    callback(this.costCodes);
                }
                resolve(this.costCodes);
                return;
            }

            this.costCodes = new PJQ.collections.budget.CostCodes();
            this.costCodes.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.costCodes);
                    }
                    resolve(this.costCodes);
                },
                error: () => {
                    if (typeof callback === 'function') {
                        callback(null);
                    }
                    reject(new Error("Failed to fetch project cost codes"));
                }
            });
        });
    },
    fetchCostTypes: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.costTypes != null) {
                if (typeof callback === 'function') {
                    callback(this.costTypes);
                }
                resolve(this.costTypes);
                return;
            }

            this.costTypes = new PJQ.collections.budget.CostTypes();
            this.costTypes.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.costTypes);
                    }
                    resolve(this.costTypes);
                },
                error: () => {
                    if (typeof callback === 'function') {
                        callback(null);
                    }
                    reject(new Error("Failed to fetch project cost types"));
                }
            })
        });
    },
    fetchTaxCodes: function (callback, force) {
        if (this.taxCodes == null || force) {
            this.taxCodes = new PJQ.collections.budget.TaxCodes();
            this.taxCodes.fetch({
                success: _.bind(function () {
                    callback(this.taxCodes);
                }, this)
            })
        } else {
            callback(this.taxCodes);
        }
    },
    fetchInspectionTypes: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.inspectionTypes != null) {
                if (typeof callback === 'function') {
                    callback(this.inspectionTypes);
                }
                resolve(this.inspectionTypes);
                return;
            }

            this.inspectionTypes = new PJQ.collections.inspections.Types();
            this.inspectionTypes.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.inspectionTypes);
                    }
                    resolve(this.inspectionTypes);
                },
                error: () => {
                    if (typeof callback === 'function') {
                        callback(null);
                    }
                    reject(new Error("Failed to fetch inspection types"));
                }
            })
        });
    },
    fetchInspectionResponseTypes: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.inspectionResponseTypes != null) {
                if (typeof callback === 'function') {
                    callback(this.inspectionResponseTypes);
                }
                resolve(this.inspectionResponseTypes);
                return;
            }

            this.inspectionResponseTypes = new PJQ.collections.inspections.ResponseTypes();
            this.inspectionResponseTypes.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.inspectionResponseTypes);
                    }
                    resolve(this.inspectionResponseTypes);
                },
                error: () => {
                    if (typeof callback === 'function') {
                        callback(null);
                    }
                    reject(new Error("Failed to fetch inspection response types"));
                }
            })
        });
    },
    fetchInspectionUserSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.inspectionUserSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.inspectionUserSettings);
                }
                resolve(this.inspectionUserSettings);
                return;
            }

            this.inspectionUserSettings = new PJQ.models.inspections.UserSettings();
            this.inspectionUserSettings.fetch({
                success: () => {
                    resolve(this.inspectionUserSettings);
                    if (typeof callback === 'function') {
                        callback(this.inspectionUserSettings);
                    }
                },
                error: () => {
                    reject(new Error("Failed to fetch inspection user settings"));
                }
            });
        });
    },
    fetchRFISettings: function (callback) {
        if (this.rfiSettings == null) {
            this.rfiSettings = new PJQ.models.rfi.Settings();
            this.rfiSettings.fetch({
                success: _.bind(function () {
                    callback(this.rfiSettings);
                }, this)
            });
        } else {
            callback(this.rfiSettings);
        }
    },
    fetchPlanRoomSettings: function (callback) {
        if (this.planRoomSettings == null) {
            this.planRoomSettings = new PJQ.models.settings.PlanRoomSettings();
            this.planRoomSettings.fetch({
                success: _.bind(function () {
                    callback(this.planRoomSettings);
                }, this)
            });
        } else {
            callback(this.planRoomSettings);
        }
    },
    fetchOrderingSettings: function (callback) {
        if (this.orderingSettings == null) {
            this.orderingSettings = new PJQ.models.settings.OrderingSettings();
            this.orderingSettings.fetch({
                success: _.bind(function () {
                    callback(this.orderingSettings);
                }, this)
            });
        } else {
            callback(this.orderingSettings);
        }
    },
    fetchAddressBookSettings: function (callback) {
        if (this.addressBookSettings == null) {
            this.addressBookSettings = new PJQ.models.settings.AddressBookSettings();
            this.addressBookSettings.fetch({
                success: _.bind(function () {
                    callback(this.addressBookSettings);
                }, this)
            });
        } else {
            callback(this.addressBookSettings);
        }
    },
    fetchActionItemCustomFields(masterUserId, callback) {
        return new Promise((resolve, reject) => {
            if (masterUserId == null) {
                masterUserId = PJQ.app.session.get('masterUserId');
            }

            if (this.customFields.actionItems[masterUserId] == null) {
                this.customFields.actionItems[masterUserId] = new PJQ.collections.actionItems.ActionItemCustomField(null, {
                    masterUserId: masterUserId
                });
                this.customFields.actionItems[masterUserId].fetch({
                    success: () => {
                        resolve(this.customFields.actionItems[masterUserId]);
                        if (typeof callback === 'function') {
                            callback(this.customFields.actionItems[masterUserId]);
                        }
                    },
                    error: () => {
                        reject(new Error("Failed to fetch action item field settings"));
                    }
                })
            } else {
                resolve(this.customFields.actionItems[masterUserId]);
                if (typeof callback === 'function') {
                    callback(this.customFields.actionItems[masterUserId]);
                }
            }
        });
    },
    fetchPunchListCustomFields(masterUserId, callback) {
        return new Promise((resolve, reject) => {
            if (masterUserId == null) {
                masterUserId = PJQ.app.session.get('masterUserId');
            }

            if (this.customFields.punchList[masterUserId] == null) {
                this.customFields.punchList[masterUserId] = new PJQ.collections.punchlists.PunchlistCustomFields(null, {
                    masterUserId: masterUserId
                });
                this.customFields.punchList[masterUserId].fetch({
                    success: () => {
                        resolve(this.customFields.punchList[masterUserId]);
                        if (typeof callback === 'function') {
                            callback(this.customFields.punchList[masterUserId]);
                        }
                    },
                    error: () => {
                        reject(new Error("Failed to fetch contract field settings"));

                        if (typeof callback === 'function') {
                            callback(this.customFields.punchList[masterUserId]);
                        }
                    }
                })
            } else {
                resolve(this.customFields.punchList[masterUserId]);
                if (typeof callback === 'function') {
                    callback(this.customFields.punchList[masterUserId]);
                }
            }
        });
    },
    fetchMeetingCustomFields(masterUserId, callback) {
        return new Promise((resolve, reject) => {
            if (masterUserId == null) {
                masterUserId = PJQ.app.session.get('masterUserId');
            }

            if (this.customFields.meetings[masterUserId] == null) {
                this.customFields.meetings[masterUserId] = new PJQ.collections.meetings.CustomFields(null, {
                    masterUserId: masterUserId
                });
                this.customFields.meetings[masterUserId].fetch({
                    success: () => {
                        resolve(this.customFields.meetings[masterUserId]);
                        if (typeof callback === 'function') {
                            callback(this.customFields.meetings[masterUserId]);
                        }
                    },
                    error: () => {
                        reject(new Error("Failed to fetch contract field settings"));
                    }
                })
            } else {
                resolve(this.customFields.meetings[masterUserId]);
                if (typeof callback === 'function') {
                    callback(this.customFields.meetings[masterUserId]);
                }
            }
        });
    },
    fetchRFICustomFields(masterUserId, callback) {
        if (masterUserId == null) {
            masterUserId = PJQ.app.session.get('masterUserId');
        }
        if (this.customFields.rfi[masterUserId] == null) {
            this.customFields.rfi[masterUserId] = new PJQ.collections.rfi.CustomFields(null, {
                masterUserId: masterUserId
            });
            this.customFields.rfi[masterUserId].fetch({
                success: _.bind(function () {
                    if (typeof callback === 'function') {
                        callback(this.customFields.rfi[masterUserId]);
                    }
                }, this)
            })
        } else {
            if (typeof callback === 'function') {
                callback(this.customFields.rfi[masterUserId]);
            }
        }
    },
    fetchContactFieldSettings(masterUserId, callback) {
        if (masterUserId == null) {
            masterUserId = PJQ.app.session.get('masterUserId');
        }
        if (this.coreFields.contact[masterUserId] == null) {
            this.coreFields.contact[masterUserId] = new PJQ.collections.contacts.ContactFieldSettings(null, {
                masterUserId: masterUserId
            });
            this.coreFields.contact[masterUserId].fetch({
                success: _.bind(function () {
                    if (typeof callback === 'function') {
                        callback(this.coreFields.contact[masterUserId]);
                    }
                }, this)
            })
        } else {
            if (typeof callback === 'function') {
                callback(this.coreFields.contact[masterUserId]);
            }
        }
    },
    fetchUserFieldSettings(masterUserId, callback) {
        if (masterUserId == null) {
            masterUserId = PJQ.app.session.get('masterUserId');
        }
        if (this.coreFields.user[masterUserId] == null) {
            this.coreFields.user[masterUserId] = new PJQ.collections.users.UserFieldSettings(null, {
                masterUserId: masterUserId
            });
            this.coreFields.user[masterUserId].fetch({
                success: _.bind(function () {
                    if (typeof callback === 'function') {
                        callback(this.coreFields.user[masterUserId]);
                    }
                }, this)
            })
        } else {
            if (typeof callback === 'function') {
                callback(this.coreFields.user[masterUserId]);
            }
        }
    },
    fetchPrimeContractFieldSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.primeContractFieldSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.primeContractFieldSettings);
                }
                resolve(this.primeContractFieldSettings);
                return;
            }

            this.primeContractFieldSettings = new PJQ.collections.primeContracts.FieldSettings();
            this.primeContractFieldSettings.fetch({
                success: () => {
                    resolve(this.primeContractFieldSettings);
                    if (typeof callback === 'function') {
                        callback(this.primeContractFieldSettings);
                    }
                },
                error: () => {
                    reject(new Error("Failed to fetch contract field settings"));
                }
            });
        });
    },
    fetchPrimeContractChangeOrderFieldSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.primeContractChangeOrderFieldSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.primeContractChangeOrderFieldSettings);
                }
                resolve(this.primeContractChangeOrderFieldSettings);
                return;
            }

            this.primeContractChangeOrderFieldSettings = new PJQ.collections.primeContracts.ChangeOrderFieldSettings();
            this.primeContractChangeOrderFieldSettings.fetch({
                success: () => {
                    resolve(this.primeContractChangeOrderFieldSettings);
                    if (typeof callback === 'function') {
                        callback(this.primeContractChangeOrderFieldSettings);
                    }
                },
                error: () => {
                    reject(new Error("Failed to fetch contract change order field settings"));
                }
            });
        });
    },
    fetchReceivableInvoiceFieldSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.receivableInvoiceFieldSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.receivableInvoiceFieldSettings);
                }
                resolve(this.receivableInvoiceFieldSettings);
                return;
            }

            this.receivableInvoiceFieldSettings = new PJQ.collections.invoicing.ReceivableInvoiceFieldSettings();
            this.receivableInvoiceFieldSettings.fetch({
                success: () => {
                    resolve(this.receivableInvoiceFieldSettings);
                    if (typeof callback === 'function') {
                        callback(this.receivableInvoiceFieldSettings);
                    }
                },
                error: () => {
                    reject(new Error("Failed to fetch receivable invoice field settings"));
                }
            });
        });
    },
    fetchCommitmentFieldSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.commitmentFieldSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.commitmentFieldSettings);
                }
                resolve(this.commitmentFieldSettings);
                return;
            }

            this.commitmentFieldSettings = new PJQ.collections.commitments.FieldSettings();
            this.commitmentFieldSettings.fetch({
                success: () => {
                    resolve(this.commitmentFieldSettings);
                    if (typeof callback === 'function') {
                        callback(this.commitmentFieldSettings);
                    }
                },
                error: () => {
                    reject(new Error("Failed to fetch commitment field settings"));
                }
            });
        });
    },
    fetchCommitmentChangeOrderFieldSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.commitmentChangeOrderFieldSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.commitmentChangeOrderFieldSettings);
                }
                resolve(this.commitmentChangeOrderFieldSettings);
                return;
            }

            this.commitmentChangeOrderFieldSettings = new PJQ.collections.commitments.ChangeOrderFieldSettings();
            this.commitmentChangeOrderFieldSettings.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.commitmentChangeOrderFieldSettings);
                    }

                    resolve(this.commitmentChangeOrderFieldSettings);
                },
                error: () => {
                    reject(new Error("Failed to fetch commitment change order field settings"));
                }
            });
        });
    },
    fetchPayableInvoiceFieldSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.payableInvoiceFieldSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.payableInvoiceFieldSettings);
                }
                resolve(this.payableInvoiceFieldSettings);
                return;
            }

            this.payableInvoiceFieldSettings = new PJQ.collections.invoicing.PayableInvoiceFieldSettings();
            this.payableInvoiceFieldSettings.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.payableInvoiceFieldSettings);
                    }

                    resolve(this.payableInvoiceFieldSettings);
                },
                error: () => {
                    reject(new Error("Failed to fetch payable invoice field settings"));
                }
            });
        });
    },
    fetchDirectCostFieldSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.directCostFieldSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.directCostFieldSettings);
                }
                resolve(this.directCostFieldSettings);
                return;
            }

            this.directCostFieldSettings = new PJQ.collections.directcosts.DirectCostFieldSettings();
            this.directCostFieldSettings.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.directCostFieldSettings);
                    }

                    resolve(this.directCostFieldSettings);
                },
                error: () => {
                    reject(new Error("Failed to fetch direct cost field settings"));
                }
            });
        });
    },
    fetchContactCustomFields(masterUserId, callback) {
        return new Promise((resolve, reject) => {
            if (masterUserId == null) {
                masterUserId = PJQ.app.session.get('masterUserId');
            }

            if (this.customFields.contact[masterUserId] != null) {
                if (typeof callback === 'function') {
                    callback(this.customFields.contact[masterUserId]);
                }
                resolve(this.customFields.contact[masterUserId]);
                return;
            }

            this.customFields.contact[masterUserId] = new PJQ.collections.contacts.ContactCustomFields(null, {
                masterUserId: masterUserId
            });
            this.customFields.contact[masterUserId].fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.customFields.contact[masterUserId]);
                    }
                    resolve(this.customFields.contact[masterUserId]);
                }
            })
        });
    },
    fetchPrimeContractCustomFields(masterUserId, callback) {
        if (masterUserId == null) {
            masterUserId = PJQ.app.session.get('masterUserId');
        }
        if (this.customFields.primeContracts[masterUserId] == null) {
            this.customFields.primeContracts[masterUserId] = new PJQ.collections.primeContracts.CustomFields(null, {
                masterUserId: masterUserId
            });
            this.customFields.primeContracts[masterUserId].fetch({
                success: _.bind(function () {
                    if (typeof callback === 'function') {
                        callback(this.customFields.primeContracts[masterUserId]);
                    }
                }, this)
            })
        } else {
            if (typeof callback === 'function') {
                callback(this.customFields.primeContracts[masterUserId]);
            }
        }
    },
    fetchPayableInvoiceCustomFields(masterUserId, callback) {
        if (masterUserId == null) {
            masterUserId = PJQ.app.session.get('masterUserId');
        }
        if (this.customFields.payableInvoices[masterUserId] == null) {
            this.customFields.payableInvoices[masterUserId] = new PJQ.collections.invoicing.PayableInvoiceCustomFields(null, {
                masterUserId: masterUserId
            });
            this.customFields.payableInvoices[masterUserId].fetch({
                success: _.bind(function () {
                    if (typeof callback === 'function') {
                        callback(this.customFields.payableInvoices[masterUserId]);
                    }
                }, this)
            })
        } else {
            if (typeof callback === 'function') {
                callback(this.customFields.payableInvoices[masterUserId]);
            }
        }
    },
    fetchPayableInvoiceUserSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.payableInvoiceUserSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.payableInvoiceUserSettings);
                }
                resolve(this.payableInvoiceUserSettings);
                return;
            }

            this.payableInvoiceUserSettings = new PJQ.models.invoicing.PayableInvoiceUserSettings();
            this.payableInvoiceUserSettings.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.payableInvoiceUserSettings);
                    }

                    resolve(this.payableInvoiceUserSettings);
                },
                error: () => {
                    reject(new Error("Failed to fetch payable invoice user settings"));
                }
            });
        });
    },
    fetchReceivableInvoiceCustomFields(masterUserId, callback) {
        if (masterUserId == null) {
            masterUserId = PJQ.app.session.get('masterUserId');
        }
        if (this.customFields.receivableInvoices[masterUserId] == null) {
            this.customFields.receivableInvoices[masterUserId] = new PJQ.collections.invoicing.ReceivableInvoiceCustomFields(null, {
                masterUserId: masterUserId
            });
            this.customFields.receivableInvoices[masterUserId].fetch({
                success: _.bind(function () {
                    if (typeof callback === 'function') {
                        callback(this.customFields.receivableInvoices[masterUserId]);
                    }
                }, this)
            })
        } else {
            if (typeof callback === 'function') {
                callback(this.customFields.receivableInvoices[masterUserId]);
            }
        }
    },
    fetchReceivableInvoiceUserSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.receivableInvoiceUserSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.receivableInvoiceUserSettings);
                }
                resolve(this.receivableInvoiceUserSettings);
                return;
            }

            this.receivableInvoiceUserSettings = new PJQ.models.invoicing.ReceivableInvoiceUserSettings();
            this.receivableInvoiceUserSettings.fetch({
                success: () => {
                    resolve(this.receivableInvoiceUserSettings);
                    if (typeof callback === 'function') {
                        callback(this.receivableInvoiceUserSettings);
                    }
                },
                error: () => {
                    reject(new Error("Failed to fetch receivable invoice user settings"));
                }
            });
        });
    },
    fetchUserCustomFields(masterUserId, callback) {
        return new Promise((resolve, reject) => {
            if (masterUserId == null) {
                masterUserId = PJQ.app.session.get('masterUserId');
            }

            if (this.customFields.user[masterUserId] != null) {
                if (typeof callback === 'function') {
                    callback(this.customFields.user[masterUserId]);
                }
                resolve(this.customFields.user[masterUserId]);
                return;
            }

            this.customFields.user[masterUserId] = new PJQ.collections.users.UserCustomFields(null, {
                masterUserId: masterUserId
            });
            this.customFields.user[masterUserId].fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.customFields.user[masterUserId]);
                    }
                    resolve(this.customFields.user[masterUserId]);
                }
            })
        });
    },
    fetchScreeningSettings: function (callback) {
        if (this.screeningSettings == null) {
            this.screeningSettings = new PJQ.models.addressBook.ProqualSettings();
            this.screeningSettings.fetch({
                success: _.bind(function () {
                    if (typeof callback === 'function') {
                        callback(this.screeningSettings);
                    }
                }, this)
            });
        } else {
            if (typeof callback === 'function') {
                callback(this.screeningSettings);
            }
        }
    },
    fetchSubmittalSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.submittalSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.submittalSettings);
                }
                resolve(this.submittalSettings);
                return;
            }

            this.submittalSettings = new PJQ.models.submittals.Settings();
            this.submittalSettings.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.submittalSettings);
                    }

                    resolve(this.submittalSettings);
                },
                error: () => {
                    reject(new Error("Failed to fetch submittal settings"));
                }
            });
        });
    },
    fetchSubmittalUserSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.submittalUserSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.submittalUserSettings);
                }
                resolve(this.submittalUserSettings);
                return;
            }

            this.submittalUserSettings = new PJQ.models.submittals.SubmittalUserSettings();
            this.submittalUserSettings.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.submittalUserSettings);
                    }

                    resolve(this.submittalUserSettings);
                },
                error: () => {
                    reject(new Error("Failed to fetch submittal user settings"));
                }
            });
        });
    },
    fetchSubmittalStatuses: function (refresh, callback) {
        return new Promise((resolve, reject) => {
            if (refresh !== true && this.submittalStatuses != null) {
                if (typeof callback === 'function') {
                    callback(this.submittalStatuses);
                }
                resolve(this.submittalStatuses);
                return;
            }

            this.submittalStatuses = new PJQ.collections.submittals.Statuses();
            this.submittalStatuses.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.submittalStatuses);
                    }

                    resolve(this.submittalStatuses);
                },
                error: () => {
                    reject(new Error("Failed to fetch submittal statuses"));
                }
            });
        });
    },
    fetchSubmittalItemTypes: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.submittalItemTypes != null) {
                if (typeof callback === 'function') {
                    callback(this.submittalItemTypes);
                }
                resolve(this.submittalItemTypes);
                return;
            }

            this.submittalItemTypes = new PJQ.collections.submittals.ItemTypes();
            this.submittalItemTypes.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.submittalItemTypes);
                    }

                    resolve(this.submittalItemTypes);
                },
                error: () => {
                    reject(new Error("Failed to fetch submittal item types"));
                }
            });
        });
    },
    fetchSubmittalCustomFields(masterUserId, callback) {
        return new Promise((resolve, reject) => {
            if (masterUserId == null) {
                masterUserId = PJQ.app.session.get('masterUserId');
            }

            if (this.customFields.submittals[masterUserId] != null) {
                if (typeof callback === 'function') {
                    callback(this.customFields.submittals[masterUserId]);
                }
                resolve(this.customFields.submittals[masterUserId]);
                return;
            }

            this.customFields.submittals[masterUserId] = new PJQ.collections.submittals.SubmittalCustomField(null, {
                masterUserId: masterUserId
            });
            this.customFields.submittals[masterUserId].fetch({
                success: () => {
                    resolve(this.customFields.submittals[masterUserId]);
                    if (typeof callback === 'function') {
                        callback(this.customFields.submittals[masterUserId]);
                    }
                },
                error: () => {
                    reject(new Error("Failed to fetch submittal custom fields"));
                }
            });
        });
    },
    fetchCompanyCustomFields(masterUserId, callback) {
        if (masterUserId == null) {
            masterUserId = PJQ.app.session.get('masterUserId');
        }
        if (this.customFields.company[masterUserId] == null) {
            this.customFields.company[masterUserId] = new PJQ.collections.contacts.CompanyCustomFields(null, {
                masterUserId: masterUserId
            });
            this.customFields.company[masterUserId].fetch({
                success: _.bind(function () {
                    if (typeof callback === 'function') {
                        callback(this.customFields.company[masterUserId]);
                    }
                }, this)
            })
        } else {
            if (typeof callback === 'function') {
                callback(this.customFields.company[masterUserId]);
            }
        }
    },
    fetchScheduleCustomFields(masterUserId, callback) {
        if (masterUserId == null) {
            masterUserId = PJQ.app.session.get('masterUserId');
        }
        if (this.customFields.schedule[masterUserId] == null) {
            this.customFields.schedule[masterUserId] = new PJQ.collections.schedule.ScheduleCustomFields(null, {
                masterUserId: masterUserId
            });
            this.customFields.schedule[masterUserId].fetch({
                success: _.bind(function () {
                    if (typeof callback === 'function') {
                        callback(this.customFields.schedule[masterUserId]);
                    }
                }, this)
            })
        } else {
            if (typeof callback === 'function') {
                callback(this.customFields.schedule[masterUserId]);
            }
        }
    },
    fetchUserTypes(callback) {
        if (this.userTypes == null) {
            this.userTypes = new PJQ.collections.userTypes.UserTypes();
        }
        if (!this.userTypes.isFetched) {
            this.userTypes.fetch({
                success: _.bind(function () {
                    if (typeof callback === 'function') {
                        callback(this.userTypes);
                    }
                }, this)
            })
        } else {
            if (typeof callback === 'function') {
                callback(this.userTypes);
            }
        }
    },
    fetchProjectStatuses(callback) {
        return new Promise((resolve, reject) => {
            if (this.projectStatuses != null) {
                if (typeof callback === 'function') {
                    callback(this.projectStatuses);
                }
                resolve(this.projectStatuses);
                return;
            }

            this.projectStatuses = new PJQ.collections.projectStatuses.ProjectStatuses();
            this.projectStatuses.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.projectStatuses);
                    }

                    resolve(this.projectStatuses);
                },
                error: () => {
                    reject(new Error("Failed to fetch project statuses"));
                }
            });
        });
    },
    fetchProjectCustomFields(masterUserId, callback) {
        return new Promise((resolve, reject) => {
            let muid = masterUserId > 0 ? masterUserId : PJQ.app.session.get('masterUserId');
            if (this.customFields.project[muid] != null) {
                if (typeof callback === 'function') {
                    callback(this.customFields.project[muid]);
                }
                resolve(this.customFields.project[muid]);
                return;
            }

            let fields = new PJQ.collections.projects.ProjectCustomFields(null, {masterUserId: muid});
            fields.fetch({
                success: () => {
                    if (muid !== PJQ.app.session.get('masterUserId')) {
                        fields = new PJQ.collections.projects.ProjectCustomFields(_.filter(fields.models, function (customField) {
                            if (customField.get('isVisibleInRSVP'))
                                return customField;
                        }));
                    }

                    this.customFields.project[muid] = fields;
                    if (typeof callback === 'function') {
                        callback(this.customFields.project[muid]);
                    }
                    resolve(this.customFields.project[muid]);
                },
                error: () => {
                    reject(new Error("Failed to fetch project custom fields"));
                }
            })
        });
    },
    fetchScheduleStatuses: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.scheduleTaskStatuses != null) {
                if (typeof callback === 'function') {
                    callback(this.scheduleTaskStatuses);
                }
                resolve(this.scheduleTaskStatuses);
                return;
            }

            this.scheduleTaskStatuses = new PJQ.collections.schedule.TaskStatuses();
            this.scheduleTaskStatuses.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.scheduleTaskStatuses);
                    }

                    resolve(this.scheduleTaskStatuses);
                },
                error: () => {
                    reject(new Error("Failed to fetch schedule task statuses"));
                }
            });
        });
    },
    fetchPrequalForm(masterUserId, callback) {
        return new Promise((resolve, reject) => {
            if (masterUserId == null) {
                masterUserId = PJQ.app.session.get('masterUserId');
            }

            if (this.prequalForms == null) {
                this.prequalForms = {};
            }

            if (this.prequalForms[masterUserId] != null) {
                if (typeof callback === 'function') {
                    callback(this.prequalForms[masterUserId]);
                }

                resolve(this.prequalForms[masterUserId]);
                return;
            }

            this.prequalForms[masterUserId] = new PJQ.models.prequal.Form({
                masterUserId: masterUserId
            });
            this.prequalForms[masterUserId].fetch({
                success: _.bind(function () {
                    if (typeof callback === 'function') {
                        callback(this.prequalForms[masterUserId]);
                    }

                    resolve(this.prequalForms[masterUserId]);
                }, this),
                error: () => {
                    reject(new Error("Failed to fetch prequal form"));
                }
            });
        });
    },
    fetchCalendarSettings: function (callback) {
        let fnCallback = _.bind(function () {
            if (typeof callback === 'function') {
                callback(this.calendarSettings);
            }
        }, this);
        if (this.calendarSettings != null) {
            fnCallback();
        } else {
            this.calendarSettings = new PJQ.models.calendars.CalendarSettings();
            this.calendarSettings.fetch({
                success: _.bind(function () {
                    fnCallback();
                }, this)
            });
        }
    },
    fetchScheduleSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.scheduleSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.scheduleSettings);
                }
                resolve(this.scheduleSettings);
                return;
            }

            this.scheduleSettings = new PJQ.models.schedule.Settings();
            this.scheduleSettings.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.scheduleSettings);
                    }
                    resolve(this.scheduleSettings);
                },
                error: () => {
                    reject(new Error("Failed to fetch schedule settings"));
                }
            });
        });
    },
    fetchUserGroups(masterUserId, callback) {
        return new Promise((resolve, reject) => {
            let smuid = PJQ.app.session.get('masterUserId');
            if (masterUserId == null || masterUserId === smuid) {
                masterUserId = -1;
            }
            if (this.groups[masterUserId] != null) {
                if (typeof callback === 'function') {
                    callback(this.groups[masterUserId]);
                }
                resolve(this.groups[masterUserId]);
                return;
            }

            let groups = new PJQ.collections.groups.Groups(null, {
                userId: masterUserId
            });
            groups.fetch({
                success: () => {
                    this.groups[masterUserId] = groups;
                    if (typeof callback === 'function') {
                        callback(this.groups[masterUserId]);
                    }
                    resolve(this.groups[masterUserId]);
                },
                error: () => {
                    reject(new Error("Failed to fetch user groups"));
                }
            })
        });
    },
    fetchProjectMessageEmailTemplates(callback) {
        return new Promise((resolve, reject) => {
            if (this.emailTemplates.projectMessage != null) {
                if (typeof callback === 'function') {
                    callback(this.emailTemplates.projectMessage);
                }
                resolve(this.emailTemplates.projectMessage);
                return;
            }

            this.emailTemplates.projectMessage = new PJQ.collections.emailTemplates.EmailTemplates(null, {projectMessage: true});
            this.emailTemplates.projectMessage.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.emailTemplates.projectMessage);
                    }
                    resolve(this.emailTemplates.projectMessage);
                },
                error: () => {
                    reject(new Error("Failed to fetch project message templates"));
                }
            });
        });
    },
    fetchUsers(callback) {
        if (this.users == null) {
            this.users = new PJQ.collections.users.Users();
        }
        if (!this.users.isFetched) {
            this.users.fetch({
                success: _.bind(function () {
                    if (typeof callback === 'function') {
                        callback(this.users);
                    }
                }, this)
            })
        } else {
            if (typeof callback === 'function') {
                callback(this.users);
            }
        }
    },
    fetchSSOProviders(callback) {
        if (this.ssoProviders == null) {
            this.ssoProviders = new PJQ.collections.sso.Providers();
        }
        if (!this.ssoProviders.isFetched) {
            this.ssoProviders.fetch({
                success: _.bind(function () {
                    if (typeof callback === 'function') {
                        callback(this.ssoProviders);
                    }
                }, this)
            })
        } else {
            if (typeof callback === 'function') {
                callback(this.ssoProviders);
            }
        }
    },
    fetchDailyReportTemplates(callback) {
        if (this.data.dailyReports.templates == null) {
            this.data.dailyReports.templates = new PJQ.collections.dailyReports.SurveyTemplates();
            this.data.dailyReports.templates.fetch({
                success: _.bind(function () {
                    if (typeof callback === 'function') {
                        callback(this.data.dailyReports.templates);
                    }
                }, this)
            })
        } else {
            if (typeof callback === 'function') {
                callback(this.data.dailyReports.templates);
            }
        }
    },
    fetchBillingInfo: function (callback) {
        if (this.billingInfo == null) {
            this.billingInfo = new PJQ.models.billing.BillingInfo();
        }

        if (!this.billingInfo.isFetched) {
            this.billingInfo.fetch({
                success: _.bind(function () {
                    callback(this.billingInfo);
                }, this)
            });
        } else {
            callback(this.billingInfo);
        }
    },
    fetchCommitmentSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.commitmentSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.commitmentSettings);
                }
                resolve(this.commitmentSettings);
                return;
            }

            this.commitmentSettings = new PJQ.models.commitments.Settings();
            this.commitmentSettings.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.commitmentSettings);
                    }

                    resolve(this.commitmentSettings);
                },
                error: () => {
                    reject(new Error("Failed to fetch commitment settings"));
                }
            });
        });
    },
    fetchCommitmentTerms: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.commitmentTerms != null) {
                if (typeof callback === 'function') {
                    callback(this.commitmentTerms);
                }
                resolve(this.commitmentTerms);
                return;
            }

            this.commitmentTerms = new PJQ.collections.commitments.Terms();
            this.commitmentTerms.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.commitmentTerms);
                    }

                    resolve(this.commitmentTerms);
                },
                error: () => {
                    reject(new Error("Failed to fetch commitment terms"));
                }
            });
        });
    },
    fetchCommitmentUserSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.commitmentUserSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.commitmentUserSettings);
                }
                resolve(this.commitmentUserSettings);
                return;
            }

            this.commitmentUserSettings = new PJQ.models.commitments.CommitmentUserSettings();
            this.commitmentUserSettings.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.commitmentUserSettings);
                    }

                    resolve(this.commitmentUserSettings);
                },
                error: () => {
                    reject(new Error("Failed to fetch commitment user settings"));
                }
            });
        });
    },
    fetchCommitmentChangeOrderSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.commitmentChangeOrderSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.commitmentChangeOrderSettings);
                }
                resolve(this.commitmentChangeOrderSettings);
                return;
            }

            this.commitmentChangeOrderSettings = new PJQ.models.commitments.ChangeOrderSettings();
            this.commitmentChangeOrderSettings.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.commitmentChangeOrderSettings);
                    }

                    resolve(this.commitmentChangeOrderSettings);
                },
                error: () => {
                    reject(new Error("Failed to fetch commitment change order settings"));
                }
            });
        });
    },
    fetchCommitmentChangeOrderUserSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.commitmentChangeOrderUserSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.commitmentChangeOrderUserSettings);
                }
                resolve(this.commitmentChangeOrderUserSettings);
                return;
            }

            this.commitmentChangeOrderUserSettings = new PJQ.models.commitments.ChangeOrderUserSettings();
            this.commitmentChangeOrderUserSettings.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.commitmentChangeOrderUserSettings);
                    }

                    resolve(this.commitmentChangeOrderUserSettings);
                },
                error: () => {
                    reject(new Error("Failed to fetch commitment change order user settings"));
                }
            });
        });
    },
    fetchDirectCostSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.directCostSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.directCostSettings);
                }
                resolve(this.directCostSettings);
                return;
            }

            this.directCostSettings = new PJQ.models.directcosts.Settings();
            this.directCostSettings.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.directCostSettings);
                    }

                    resolve(this.directCostSettings);
                },
                error: () => {
                    reject(new Error("Failed to fetch direct cost settings"));
                }
            });
        });
    },
    fetchMeetingSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.meetingSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.meetingSettings);
                }
                resolve(this.meetingSettings);
                return;
            }

            this.meetingSettings = new PJQ.models.meetings.Settings();
            this.meetingSettings.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.meetingSettings);
                    }

                    resolve(this.meetingSettings);
                },
                error: () => {
                    reject(new Error("Failed to fetch meetings settings"));
                }
            });
        });
    },
    fetchDirectCostUserSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.directCostUserSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.directCostUserSettings);
                }
                resolve(this.directCostUserSettings);
                return;
            }

            this.directCostUserSettings = new PJQ.models.directcosts.UserSettings();
            this.directCostUserSettings.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.directCostUserSettings);
                    }

                    resolve(this.directCostUserSettings);
                },
                error: () => {
                    reject(new Error("Failed to fetch direct cost user settings"));
                }
            });
        });
    },
    fetchPrimeContractTerms: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.primeContractTerms != null) {
                if (typeof callback === 'function') {
                    callback(this.primeContractTerms);
                }
                resolve(this.primeContractTerms);
                return;
            }

            this.primeContractTerms = new PJQ.collections.primeContracts.Terms();
            this.primeContractTerms.fetch({
                success: () => {
                    resolve(this.primeContractTerms);
                    if (typeof callback === 'function') {
                        callback(this.primeContractTerms);
                    }
                },
                error: () => {
                    reject(new Error("Failed to fetch contract terms"));
                }
            });
        });
    },
    fetchPrimeContractSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.primeContractSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.primeContractSettings);
                }
                resolve(this.primeContractSettings);
                return;
            }

            this.primeContractSettings = new PJQ.models.primeContracts.Settings();
            this.primeContractSettings.fetch({
                success: () => {
                    resolve(this.primeContractSettings);
                    if (typeof callback === 'function') {
                        callback(this.primeContractSettings);
                    }
                },
                error: () => {
                    reject(new Error("Failed to fetch contract settings "));
                }
            });
        });
    },
    fetchPrimeContractUserSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.primeContractUserSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.primeContractUserSettings);
                }
                resolve(this.primeContractUserSettings);
                return;
            }

            this.primeContractUserSettings = new PJQ.models.primeContracts.PrimeContractUserSettings();
            this.primeContractUserSettings.fetch({
                success: () => {
                    resolve(this.primeContractUserSettings);
                    if (typeof callback === 'function') {
                        callback(this.primeContractUserSettings);
                    }
                },
                error: () => {
                    reject(new Error("Failed to fetch contract user settings"));
                }
            });
        });
    },
    fetchPrimeContractChangeOrderSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.primeContractChangeOrderSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.primeContractChangeOrderSettings);
                }
                resolve(this.primeContractChangeOrderSettings);
                return;
            }

            this.primeContractChangeOrderSettings = new PJQ.models.primeContracts.ChangeOrderSettings();
            this.primeContractChangeOrderSettings.fetch({
                success: () => {
                    resolve(this.primeContractChangeOrderSettings);
                    if (typeof callback === 'function') {
                        callback(this.primeContractChangeOrderSettings);
                    }
                },
                error: () => {
                    reject(new Error("Failed to fetch contract change order settings"));
                }
            });
        });
    },
    fetchPrimeContractChangeOrderUserSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.primeContractChangeOrderUserSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.primeContractChangeOrderUserSettings);
                }
                resolve(this.primeContractChangeOrderUserSettings);
                return;
            }

            this.primeContractChangeOrderUserSettings = new PJQ.models.primeContracts.ChangeOrderUserSettings();
            this.primeContractChangeOrderUserSettings.fetch({
                success: () => {
                    resolve(this.primeContractChangeOrderUserSettings);
                    if (typeof callback === 'function') {
                        callback(this.primeContractChangeOrderUserSettings);
                    }
                },
                error: () => {
                    reject(new Error("Failed to fetch contract change order user settings"));
                }
            });
        });
    },
    fetchChangeRequestSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.changeRequestSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.changeRequestSettings);
                }
                resolve(this.changeRequestSettings);
                return;
            }

            this.changeRequestSettings = new PJQ.models.changeRequests.Settings();
            this.changeRequestSettings.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.changeRequestSettings);
                    }

                    resolve(this.changeRequestSettings);
                },
                error: () => {
                    reject(new Error("Failed to fetch change request custom fields"));
                }
            });
        });
    },
    fetchChangeRequestUserSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.changeRequestUserSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.changeRequestUserSettings);
                }
                resolve(this.changeRequestUserSettings);
                return;
            }

            this.changeRequestUserSettings = new PJQ.models.changeRequests.ChangeRequestUserSettings();
            this.changeRequestUserSettings.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.changeRequestUserSettings);
                    }

                    resolve(this.changeRequestUserSettings);
                },
                error: () => {
                    reject(new Error("Failed to fetch change request user settings"));
                }
            });
        });

        if (this.changeRequestUserSettings == null) {
            this.changeRequestUserSettings = new PJQ.models.changeRequests.ChangeRequestUserSettings();
            this.changeRequestUserSettings.fetch({
                success: _.bind(function () {
                    callback(this.changeRequestUserSettings);
                }, this)
            });
        } else {
            callback(this.changeRequestUserSettings);
        }
    },
    isLoggedIn: function () {
        return this.user != null && this.user.id > 0;
    },
    hasFeature: function (feature) {
        if (this.subscription == null) {
            return false;
        }
        return this.subscription.hasFeature(feature);
    },
    updateTrial: function (subscriptionId, onSuccess, onError) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'trial'
                }
            ], [
                {
                    parameter: 'id',
                    value: subscriptionId
                }
            ])
        }).put().done(_.bind(function (data) {
            if (data == null || data.subscription == null) {
                if (typeof onError === 'function') {
                    onError(data);
                }
            }

            this.subscriptionChanged(data.subscription);

            if (typeof onSuccess === 'function') {
                onSuccess(data);
            }
        }, this)).fail(_.bind(function (data) {
            if (typeof onError === 'function') {
                onError(data);
            }
        }, this));
    },
    changeSubscription: function (subscriptionId, onSuccess, onError) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'subscription'
                }
            ], [
                {
                    parameter: 'id',
                    value: subscriptionId
                }
            ])
        }).put().done(_.bind(function (data) {
            if (data == null || data.subscription == null) {
                if (typeof onError === 'function') {
                    onError(data);
                }
            }

            this.subscriptionChanged(data.subscription);

            if (typeof onSuccess === 'function') {
                onSuccess(data);
            }
        }, this)).fail(_.bind(function (data) {
            if (typeof onError === 'function') {
                onError(data);
            }
        }, this));
    },
    subscriptionChanged: function (sub) {
        if (sub instanceof PJQ.models.subscriptions.Subscription) {
            this.subscription = sub;
        } else {
            this.subscription = new PJQ.models.subscriptions.Subscription(sub);
        }

        if (this.subscription.newSubscription == null) {
            $('.alert-sub-expiration').remove();
        }

        PJQ.app.navigator.renderHeaderSubscription();
        PJQ.app.navigator.refreshCommands();
        PJQ.app.navigator.renderActiveItem();

        if (this.subscriptionChangedListeners != null) {
            _.each(this.subscriptionChangedListeners, function (listener) {
                listener();
            });
        }
    },
    listenSubscriptionChanged: function (id, callback) {
        if (typeof callback !== 'function') {
            return;
        }

        if (this.subscriptionChangedListeners == null) {
            this.subscriptionChangedListeners = {};
        }
        this.subscriptionChangedListeners[id] = callback;
    },
    updateAutoRenew: function (enable, onSuccess, onError) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'autorenew'
                }
            ], [
                {
                    parameter: 'enable',
                    value: enable
                }
            ])
        }).put().done(_.bind(function (data) {
            if (data == null || data.subscription == null) {
                if (typeof onError === 'function') {
                    onError(data);
                }
            }

            this.subscriptionChanged(data.subscription);

            if (this.subscription.newSubscription == null) {
                $('.alert-sub-expiration').remove();
            }

            if (typeof onSuccess === 'function') {
                onSuccess(data);
            }
        }, this)).fail(_.bind(function (data) {
            if (typeof onError === 'function') {
                onError(data);
            }
        }, this));
    },
    changeUserSeats: function (userSeats, onSuccess, onError) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'userseats'
                }
            ], [
                {
                    parameter: 'userSeats',
                    value: userSeats
                }
            ])
        }).put().done(_.bind(function (data) {
            if (data == null || data.subscription == null) {
                if (typeof onError === 'function') {
                    onError(data);
                }
            }

            this.subscriptionChanged(data.subscription);

            if (typeof onSuccess === 'function') {
                onSuccess(data);
            }
        }, this)).fail(_.bind(function (data) {
            if (typeof onError === 'function') {
                onError(data);
            }
        }, this));
    }
});